import { useState, useEffect } from 'react'

import {
  Box,
  Chip,
  TablePagination,
  useMediaQuery,
  Button,
} from '@material-ui/core'

import qs from 'query-string'
import { useLocation, useHistory } from 'react-router-dom'

import {
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from 'components/Table'

import PerfectScrollbar from 'react-perfect-scrollbar'

import useStyles from './styles'

import helpers from 'helpers'

import { useTheme } from '@material-ui/styles'

import { DetailsAddressDialog } from './components'

import { MenuButton } from 'components'

const TableRowAddress = ({ address, fullScreen, ...rest }) => {
  const classes = useStyles()

  const [detailsDialogOpen, setDetailsDialogOpen] = useState(false)

  return (
    <TableRow {...rest}>
      <TableCell overFlowSize="46px">{address.id}</TableCell>
      <TableCell overFlowSize="92px">{address.country}</TableCell>
      <TableCell overFlowSize="92px">{address.state}</TableCell>
      <TableCell overFlowSize="138px">{address.city}</TableCell>
      <TableCell disableTooltip>
        {address.main === true ? (
          <Chip size="small" className={classes.chipMain} label="Principal" />
        ) : (
          <Chip
            size="small"
            className={classes.chipSecondary}
            label="Secundário"
          />
        )}
      </TableCell>
      <TableCell disableTooltip align="right">
        <MenuButton>
          <Button
            fullWidth
            size="small"
            onClick={() => {
              setDetailsDialogOpen(true)
            }}
          >
            Detalhes
          </Button>
        </MenuButton>
      </TableCell>
      <DetailsAddressDialog
        address={address}
        open={detailsDialogOpen}
        setOpen={setDetailsDialogOpen}
        fullScreen={fullScreen}
      />
    </TableRow>
  )
}

const PartnerAddressesTable = ({ addresses, fullScreen = false }) => {
  const [perPage, setPerPage] = useState(3)

  const theme = useTheme()
  const location = useLocation()
  const history = useHistory()
  const isDesktop = useMediaQuery(theme.breakpoints.up('sm'), {
    defaultMatches: true,
  })

  const search = qs.parse(location.search)

  const setPageAddresses = () => {
    return (parseInt(search.pageAddresses) || 1) - 1
  }

  const length = addresses.length

  const slices = helpers.functions.paginateArray(addresses, perPage)

  const [query, setQuery] = useState({ pageAddresses: 1, ...search })

  const verifySearchParams = () => {
    if (parseInt(search.pageAddresses) <= 0) {
      return 0
    } else {
      return setPageAddresses()
    }
  }

  const pageAddresses = verifySearchParams()

  const [addressList, setContactList] = useState(
    length > 0 && parseInt(search.pageAddresses) >= 0 && slices[pageAddresses]
      ? addresses?.slice(slices[pageAddresses][0], slices[pageAddresses][1])
      : [],
  )

  const handleChangePage = (event, newPage) => {
    setQuery({ ...search, pageAddresses: newPage + 1 })
  }

  const handleChangeRowsPerPage = (event, value) => {
    if (slices[verifySearchParams()]) setQuery({ ...search, pageContacts: 1 })
    setPerPage(value.props.value)
  }

  useEffect(() => {
    const pageIndex = verifySearchParams()

    history.replace(location.pathname + '?' + qs.stringify(query))

    if (length > 0 && pageIndex >= 0 && slices[pageIndex]) {
      setContactList(
        addresses?.slice(slices[pageIndex][0], slices[pageIndex][1]),
      )
    }
    // eslint-disable-next-line
  }, [search.pageAddresses, query])

  return (
    <Box width="100%">
      <PerfectScrollbar
        options={{ wheelPropagation: false, useBothWheelAxes: true }}
      >
        <Table size="small" emptyMessage="Nenhum endereço encontrado">
          <TableHead>
            <TableRow>
              <TableCell width="10%">Identificador</TableCell>
              <TableCell width="20%">Pais</TableCell>
              <TableCell width="20%">Estado</TableCell>
              <TableCell width="20%">Cidade</TableCell>
              <TableCell width="20%">Tipo</TableCell>
              <TableCell width="10%" align="right">
                Ações
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {addressList?.map((address) => (
              <TableRowAddress
                address={address}
                key={address.id}
                fullScreen={fullScreen}
                hover
              />
            ))}
          </TableBody>
        </Table>
      </PerfectScrollbar>
      <TablePagination
        component="div"
        count={length}
        onChangePage={handleChangePage}
        onChangeRowsPerPage={handleChangeRowsPerPage}
        page={query.pageAddresses - 1}
        rowsPerPage={perPage}
        rowsPerPageOptions={[3, 6, 9, 12]}
        labelRowsPerPage={isDesktop ? 'Por página' : ''}
        nextIconButtonProps={{ size: 'small' }}
        backIconButtonProps={{ size: 'small' }}
      />
    </Box>
  )
}

export default PartnerAddressesTable
